const [d] = [document];

export default function mobileMenu () {
  const overlay = '<div class="drawer-overlay">';
  d.body.insertAdjacentHTML('beforeend', overlay );

  const menu = d.querySelector('.main-menu__block');
  const btnOpen = d.querySelector('.menu-btn--open');
  const btnsClose = d.querySelectorAll('.btn-close');
  const navbarBrand = d.querySelector('.navbar-brand');
  const menuItems = menu.querySelectorAll('.nav-item');

  // Mobile Menu
  btnOpen.addEventListener('click', () => {
    menu.classList.add('active');
    d.body.classList.add('is-drawerActive');
    setTimeout(() => {
      navbarBrand.classList.add('active');
    }, 300);
  });

  btnsClose.forEach(btn => {
    btn.addEventListener('click', () => {
      btn.parentNode.classList.remove('active');
      navbarBrand.classList.remove('active');
      d.body.classList.remove('is-drawerActive');
    })
  });

  menuItems.forEach(item => {
    const $indicator = $(`<button class="nav-link__indicator btn">`);
    if( item.querySelectorAll('.sub-menu').length ) {
      $(item).append( $indicator );
    }

    $indicator.on('click', (evt) => {
      $(item).find('.sub-menu').slideToggle('fast', 'swing');
      $(item).toggleClass('open');
    });
  });
}